/**
 * @file Namespace.js
 *
 * @author Stanley Clark <stanley@studyportals.com>
 * @copyright © 2016 StudyPortals B.V., all rights reserved.
 * @version 1.1.0
 *
 * A first implementation of easy namespacing for our application.
 */

var StudyPortals = window.StudyPortals || {};

/**
 * Creates a namespace(object) if not existing.
 *
 * The namespace follows the pattern NAME.NAME.NAME
 *
 * @param namespaceString
 */

const prepareNamespace = function (namespaceString) {
	'use strict';

	let parts = namespaceString.split('.'),
		parentNamespace = StudyPortals,
		partsLength;

	if (parts[0] === 'StudyPortals') {
		// Remove the StudyPortals top level object reference if there
		parts = parts.slice(1);
	}

	partsLength = parts.length;

	for (let i = 0; i < partsLength; i++) {
		// Create a property if it doesn't exist

		if (typeof parentNamespace[parts[i]] === 'undefined') {
			parentNamespace[parts[i]] = {};
		}

		parentNamespace = parentNamespace[parts[i]];
	}
};

const checkNamespace = function (namespaceString) {
	let parts = namespaceString.split('.'),
		parentNamespace = StudyPortals,
		partsLength;

	if (parts[0] === 'StudyPortals') {
		// Remove the StudyPortals top level object reference if there
		parts = parts.slice(1);
	}

	partsLength = parts.length;
	let exists = true;

	for (let i = 0; i < partsLength; i++) {
		// Create a property if it doesn't exist

		if (typeof parentNamespace[parts[i]] === 'undefined') {
			exists = false;
			i = partsLength;
		}

		parentNamespace = parentNamespace[parts[i]];
	}

	return exists;
};

export { prepareNamespace, checkNamespace };
